module.exports = __webpack_public_path__ + "img/tringo_sad.54edb7ed.png";